import * as types from './mutation-types';
import { defaultState } from './state';

const resetState_ = state => {
	Object.assign(state, defaultState);
};
export default {
	resetState_,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},

	[types.SET_OPTION_CODE_LIST]: (state, { key, list }) => {
		let list_new = [{ label: 'All', value: '' }];
		list.map(item => {
			list_new.push({ label: item.CODE, value: item.CODE_NAME });
		});
		state[key] = list_new;
	},

	[types.ADD_IMAGE_FILE]: (state, { key, filename, url }) => {
		state.GuideBoardDetailValue[key].push({ name: filename, url: url });
	},

	[types.SET_SEARCH_PARAM]: (state, params) => {
		state.searchParams = { ...state.searchParams, ...params };
	},

	[types.SET_MODAL_VALUE]: (state, { key, value }) => {
		state.GuideBoardModalValue[key] = value;
	},

	[types.SET_DETAIL_VALUE]: (state, { key, value }) => {
		state.GuideBoardDetailValue[key] = value;
	}
};
